// extracted by mini-css-extract-plugin
module.exports = {"test":"GroupTypeList_test_3wL0c","headerRow":"GroupTypeList_headerRow_3dKlU","bodyRow":"GroupTypeList_bodyRow_2jAGU"};